module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('TabsMenu', {
    attrs: {
      "current": _vm.current,
      "items": _vm.menu
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._t("default", null, {
    "currentView": _vm.currentComponent,
    "currentProps": _vm.currentTab
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca0bc150","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/tab/new/Tabs.vue
// module id = eeb74a207e5428f6ed07
// module chunks = 5